import { pagingStore } from '@/stores/pagingStore';

import { LoadSegmentsRequest } from '@/models/LoadSegmentsRequest';

import { confugrationApi } from '@/api/configurationApi'
import { segmentsApi } from '@/api/segmentsApi';
import { fileApi } from '@/api/fileApi';
import { documentApi } from '@/api/documentApi'

export class documentService {
    pagingStore: any

    constructor() {
        this.pagingStore = pagingStore();
    }

    async translateThisPage(documentId: number, useExternalTranslations: boolean) {
        const pageNumber = this.pagingStore.currentPageNumber;
        const pagesize = this.pagingStore.pageSize;

        return documentApi.translateDocument(documentId, pageNumber, pagesize, useExternalTranslations);
    }

    async translateDocument(documentId: number, useExternalTranslations: boolean) {
        const pagesize = this.pagingStore.pageSize;

        return documentApi.translateDocument(documentId, -1, pagesize, useExternalTranslations);
    }

    async saveTranslationDrafts(documentId: number, includeEdited: boolean) {
        return documentApi.saveTranslationDrafts(documentId, includeEdited);
    }

    async clearFileTranslations(documentId: number) {
        const pagesize = this.pagingStore.pageSize;

        return segmentsApi.clearFileTranslations(documentId, pagesize);
    }

    async loadTranslationSegments(request: LoadSegmentsRequest) {
        return segmentsApi.getDocumentSegments(request)
    }

    async loadConfigurations(documentId: number) {
        return confugrationApi.getTranslationConfig(documentId)
    }

    async loadSegmentCounts(documentId: number) {
        return documentApi.getSegmentCounts(documentId)
    }

    async downloadDocument(documentId: Number) {
        return fileApi.downloadDocument(documentId)
    }

    async saveConfig(documentId: Number, docConfiguration: any) {
        return confugrationApi.updateConfiguration(documentId, docConfiguration);
    }

    async findNextWorkSegment(documentId: number, segmentId: number) {
        const pageSize = this.pagingStore.pageSize;

        return segmentsApi.findNextWorkSegment(documentId, pageSize, segmentId);
    }
}
